import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import useAuthStore from '../store/authStore';

export function ProtectedRoute({ children, requireAdmin = false, requireSuperuser = false }) {
  const { isAuthenticated, hasHydrated } = useAuthStore();
  const { canAccessAdminPanel } = usePermissions();
  const { user } = useAuthStore.getState();

  // Wait for hydration to complete
  if (!hasHydrated) {
    return <div>Loading...</div>;
  }

  // Check authentication
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check admin access if required
  if (requireAdmin && !canAccessAdminPanel()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check superuser access if required
  if (requireSuperuser && user?.role !== 'superuser') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
